import { ConfirmPaymentLineItemResult, ICustomFieldViewModel, WebGivingPaymentResultStatus, SplitLineItemDto } from '../webgiving-generated';
import { calculateFee } from './helper-utils';
import { getFundName } from './reference-field-helper';

export const splitLineItemSuccessStatuses = [
    WebGivingPaymentResultStatus.TimedOut,
    WebGivingPaymentResultStatus.Success,
    WebGivingPaymentResultStatus.Processing,
    WebGivingPaymentResultStatus.Delayed,
    WebGivingPaymentResultStatus.Poll
];


export type SplitLineItem = Pick<SplitLineItemDto, 'Amount' | 'FundKey'> & { AmountWithFees?: number};

export const getLineItemsAmountWithFees = (lineItems: SplitLineItem[], transactionFeeRate: number, isPayerCoveringFees: boolean = false) => {
    return lineItems.map((lineItem) => {
        const { FundKey, Amount } = lineItem;
        const amountWithFees = isPayerCoveringFees ? Number(calculateFee(Amount, transactionFeeRate).toFixed(2)) : Amount;
        return {
            FundKey: FundKey,
            Amount: Amount,
            AmountWithFees: amountWithFees
        }
    })
}

export const constructSplitLineItemResults = (
    confirmPaymentLineItemResults: ConfirmPaymentLineItemResult[] | null,
    customFields: ICustomFieldViewModel[] | null
) => {
    if (!confirmPaymentLineItemResults) {
        return [];
    }
    return confirmPaymentLineItemResults.map((lineItemResult) => {
        const fundName = getFundName(lineItemResult.FundKey, customFields);
        return {
            FundKey: lineItemResult.FundKey,
            Amount: lineItemResult.Amount,
            FundName: fundName,
            paymentStatus: lineItemResult.Status
        };
    })
}
